var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"baseDiv",staticClass:"fixed-left",class:( _obj = {}, _obj['closed'] = !_vm.sliderOpen && !_vm.initClosed, _obj['full_closed'] = _vm.initClosed, _obj ),style:(("max-width: " + _vm.size + "; min-width: " + _vm.size + ";"))},[_c('div',{staticClass:"card-slot",class:( _obj$1 = {}, _obj$1['closed-slot'] = !_vm.sliderOpen, _obj$1 )},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }